import React from "react";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";
import menu1 from "assets/img/ChaloMenu 1.jpg"
import menu2 from "assets/img/ChaloMenu 2.jpg"
import menu3 from "assets/img/ChaloMenu 3.jpg"
import menu4 from "assets/img/ChaloMenu 4.jpg"

// core components

function Download() {
  return (
    <>
      <div
        className="section section-download"
        data-background-color="black"
        id="download-section"
      >
        <Container>

        <Row className="justify-content-md-center">
            <Col className="text-center" lg="8" md="12">
              <h3 className="title">For Menu/Order/Delivery</h3>
              <h5 className="description">
                Please use one of the below options for Ordering<br/>
                <b>##We also provide catering for various events##</b>
               </h5>
            </Col>
            <Col className="text-center" lg="8" md="12">
              <Button
                className="btn-round mr-1"
                color="info"
                href="https://kinre.com/ch216"
                role="button"
                target="_blank"
                size="lg"
              >
                Online Order via kinre
              </Button>
              <Button
                className="btn-round"
                color="primary"
                href="#"
                outline
                role="button"
                size="lg"
                target="_blank"
              >
                <a href="tel:+919494710123">Call Us</a>
              </Button>
              <Button
                className="btn-round"
                color="primary"
                href="#"
                outline
                role="button"
                size="lg"
                target="_blank"
              >
                <a href="https://wa.me/+919494710123" target="_blank">WatsApp</a>
              </Button>
            </Col>
          </Row>
          <Row className="justify-content-md-center sharing-area text-center">
            <Col className="text-center" lg="12" md="12" sm="12">
              <h3 className="title">Menu</h3>
            </Col>
            <Row className="justify-content-md-center sharing-area text-center">
            <Col className="text-center">
              <img src={menu1}></img>
            </Col>
            </Row>
            <Row className="justify-content-md-center sharing-area text-center">
            <Col className="text-center">
              <img src={menu2}></img>
            </Col>
            </Row><Row className="justify-content-md-center sharing-area text-center">
            <Col className="text-center">
              <img src={menu3}></img>
            </Col>
            </Row>
            <Row className="justify-content-md-center sharing-area text-center">
            <Col className="text-center">
              <img src={menu4}></img>
            </Col>
            </Row>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Download;
